import { render, staticRenderFns } from "./ReceiptReport.vue?vue&type=template&id=10168bf4&scoped=true"
import script from "./ReceiptReport.vue?vue&type=script&lang=js"
export * from "./ReceiptReport.vue?vue&type=script&lang=js"
import style0 from "./ReceiptReport.vue?vue&type=style&index=0&id=10168bf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10168bf4",
  null
  
)

export default component.exports